// Components
// Utils
import { getText } from 'i18n/intl';
import { ERelationType } from '@timeedit/types/lib/enums';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Types
import type { IProps } from './SectionProps.interface';
// Styles
import './GeneralInfo.scss';

const GeneralInfo = ({ relationType, onChange }: IProps) => {
  return (
    <TEDrawerSection label="General Info">
      <div className="relation-type-general-info">
        <TEInput.Select
          options={Object.values(ERelationType)
            .map((type) => ({
              label: getText(type),
              value: type,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))}
          value={relationType.relationType}
          onChange={(val) => onChange('relationType', val)}
          label="Type"
          tooltip="Type"
          data-testid="relation-type"
        />
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={relationType.name}
          onChange={(val) => onChange('name', val)}
          placeholder={getText('new_relation_type')}
          data-testid="relation-name"
        />
        <TEInput.PureText
          label="Id"
          tooltip="Id"
          value={String(relationType.id)}
        />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
